export default __webpack_public_path__ + "static/media/BMMF02.07aa3673.png";